var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Functions = OCS.WxBriefing.Functions || {};
OCS.WxBriefing.Classes.Popup = new Class({
    Extends: OCS.Classes.MooPopup,
    debug: false,
    options: {
        popup_id: 'popup',
        popup_template_fields: {
            popup_wrapper_class: 'popup_wrapper',
            popup_content_container_class: 'popup_content_container' // The class for the content container 
        },
        popup_close_template_fields: {
            popup_title_class: 'popup_title title',
            popup_title_text: '',
            popup_timestamp_text: '',
            popup_timestamp_class: 'timestamp right right-margin'
        },
        popup_template: '<div class="{{popup_wrapper_class}}"><div class="{{popup_content_class}}">{{{popup_close_content}}}<div class="{{popup_content_container_class}}">{{{popup_content}}}</div></div></div>',
        popup_template_close: '<div class="{{popup_close_container_class}}"><div class="{{popup_title_class}}">{{popup_title_text}}</div>Click the red "x" or press "esc" to close<div class="{{popup_close_button_class}}"></div> <span class="{{popup_timestamp_class}}">{{popup_timestamp_text}}</span></div>',
        content_data: null,
    },

    make_request: function () {

    },

    process_form_content: function (container) {
        this.parent(container);

        var window_size = window.getSize();
        var container_w = window_size.x * 0.9;
        var container_h = window_size.y * 0.75;

        var content_el = container.getElement('.' + this.options.popup_template_fields.popup_content_container_class);
        this.content_data.inject(content_el);
        this.popup_title = container.getElement('.popup_title');
        this.popup_timestamp = container.getElement('.timestamp');

        container.getElement('.' + this.options.popup_template_fields.popup_wrapper_class).setStyle('width', container_w).setStyle('height', container_h);
        container.getElement('.' + this.options.popup_template_fields.popup_content_container_class).setStyle('height', container_h - 40);
    },
    set_popup_data: function (panel) {
        this.content_data = panel;
        this.set_popup_content(null);
        this.set_title('');
        this.set_timestamp('');
    },
    set_title: function (title) {
        this.options.popup_close_template_fields.popup_title_text = title;
        if (this.popup_title) {
            this.popup_title.set('html', title);
        }
    }
});